export default {
    type: 'toggle',
    format: {},
    default: {
        logic: 'match',
        value: 'yes'
    },
    setting: {
        logic: []
    },
    options: {
        yes: 'Yes',
        no: 'No'
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Has Commented',
        category: ['User', 'Collection'],
        description: 'Whether the user has commented on the game or not.',
        summarise: {
            template: {
                yes: 'User has commented on the game',
                no: 'User has not commented on the game'
            }
        }
    }
}